import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/ui/layout/src/lib/drawer/Drawer.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/ui/layout/src/lib/layout/Layout.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/ui/layout/src/lib/layout/MainPage.styles.ts");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/utils/apollo/src/lib/ApolloClientSide.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/utils/apollo/src/lib/CbexRegistryApollo/CbexRegistryApolloClientSide.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/utils/apollo/src/lib/SCEVApollo/SCEVApolloClientSide.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/utils/apollo/src/lib/WebshopApollo/WebshopApolloClientSide.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/utils/approuterconfig/src/lib/ClientProviders.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/utils/approuterconfig/src/lib/IntlProvider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/utils/approuterconfig/src/lib/ScevClientProviders.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/utils/context/src/index.ts");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/libs/utils/theme/src/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/tmp/build/44575cf5/repo/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/node_modules/@fontsource/roboto/300.css");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/node_modules/@fontsource/roboto/400.css");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/node_modules/@fontsource/roboto/500.css");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/node_modules/@fontsource/roboto/700.css");
;
import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/node_modules/@fontsource/material-icons/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build/44575cf5/repo/node_modules/@mui/material/esm/Paper/Paper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build/44575cf5/repo/node_modules/@mui/material/esm/Stack/Stack.js");
